import { render, staticRenderFns } from "./PH1V_S45.vue?vue&type=template&id=31563945&scoped=true"
import script from "./PH1V_S45.vue?vue&type=script&lang=js"
export * from "./PH1V_S45.vue?vue&type=script&lang=js"
import style0 from "./PH1V_S45.vue?vue&type=style&index=0&id=31563945&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31563945",
  null
  
)

export default component.exports